import { FormattedMessage } from 'react-intl';

import CloseIcon from '@/assets/icons/close.svg?react';

import styles from './InformationBar.module.scss';

interface InformationBarProps {
  title: string;
  onClick?: () => void;
  onClose?: () => void;
}

const InformationBar: React.FC<InformationBarProps> = ({
  title,
  onClick,
  onClose,
}) => (
  <div className={styles.wrapper}>
    <div className={styles.inner}>
      <a className={styles.link} onClick={onClick}>
        {title}
      </a>
      <button className={styles.button} onClick={onClick}>
        <FormattedMessage id="informationBar.button" />
      </button>
    </div>
    <button className={styles.closeButton} onClick={onClose}>
      <span aria-hidden>
        <CloseIcon />
      </span>
    </button>
  </div>
);

export default InformationBar;
